import { Heading, Text } from 'grommet'
import { useTranslation } from 'next-i18next'

import { Group } from 'db-tables'
import Layout from 'components/layout/Layout'
import DisplayDate from 'components/DisplayDate'

export default function FutureGroupLayout({ group }: { group: Group }) {
  const { t } = useTranslation()
  return (
    <Layout title={t('pages.group.future-group.title')}>
      <Heading size="small">{t('pages.group.future-group.title')}</Heading>
      <Text>{t('pages.group.future-group.starting-on')}</Text>
      <DisplayDate
        size="large"
        weight="bold"
        date={group.start_time ?? group.created_at ?? new Date()}
      />
    </Layout>
  )
}
